import hasItems from './hasItems';

export default function canViewCart(cart) {
  return hasItems(cart);
}
